export default function SectionHeader({ eyebrow, title, accentWord, accentSerif = false, dark = false, description, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow ? (
        <p className={`eyebrow mb-5 ${dark ? "text-blue-400" : "text-blue-600"}`}>{eyebrow}</p>
      ) : null}
      <h2
        className={`font-display text-3xl md:text-5xl tracking-tight font-medium leading-[1.05] ${
          dark ? "text-white" : "text-slate-900"
        }`}
      >
        {title}{" "}
        {accentWord ? (
          accentSerif ? (
            <span className="font-serif-accent text-blue-600">{accentWord}</span>
          ) : (
            <span className="text-blue-600">{accentWord}</span>
          )
        ) : null}
      </h2>
      {description ? (
        <p className={`mt-5 text-lg leading-relaxed max-w-2xl ${dark ? "text-slate-400" : "text-slate-600"} ${align === "center" ? "mx-auto" : ""}`}>
          {description}
        </p>
      ) : null}
    </div>
  );
}
